import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/StockistMissedCall.css";
import{ BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";

const StockistMissedCall = () => {
    const [states, setStates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedState, setSelectedState] = useState("");
    const [selectedDivision, setSelectedDivision] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [stockists, setStockists] = useState([]);
    const [loading, setLoading] = useState(false);

    // Load states on component mount
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/api/states`,{
                    headers:getAuthHeaders()
                });
                setStates(response.data);
            } catch (err) {
                console.error("Error fetching states:", err);
            }
        };
        fetchStates();
    }, []);

    const handleStateChange = async (stateId) => {
        setSelectedState(stateId);
        setSelectedDivision("");
        setSelectedEmployee("");
        setDivisions([]);
        setEmployees([]);
        setStockists([]);

        if (stateId) {
            try {
                const response = await axios.get(
                    `${BASE_URL}/api/divisions?state_id=${stateId}`,{
                        headers:getAuthHeaders()
                    }
                );
                setDivisions(response.data);
            } catch (err) {
                console.error("Error fetching divisions:", err);
            }
        }
    };

    const handleDivisionChange = async (divisionId) => {
        setSelectedDivision(divisionId);
        setSelectedEmployee("");
        setEmployees([]);
        setStockists([]);
    
        if (divisionId && selectedState) {
            try {
                // First find the division name from the divisions list
                const division = divisions.find(d => d.id == divisionId);
                const divisionName = division?.name;
                
                if (!divisionName) {
                    console.error("Division name not found for ID:", divisionId);
                    return;
                }
    
                console.log("Fetching employees for:", {
                    state_id: selectedState,
                    division: divisionName
                });
    
                // Use division NAME (not ID) in the API call
                const response = await axios.get(
                    `${BASE_URL}/api/employees?state_id=${selectedState}&division=${divisionName}`,{
                    headers: getAuthHeaders() // ✅ Only pass the auth header here
                }
                );
                
                console.log("Employees fetched:", response.data);
                setEmployees(response.data);
            } catch (err) {
                console.error("Error fetching employees:", err);
            }
        }
    };
    

    const filterStockists = async () => {
    if (!selectedEmployee) {
        alert("Please select an employee");
        return;
    }

    setLoading(true);
    try {
        // Prepare query parameters
        const params = {
            state_id: selectedState,
            employee_id: selectedEmployee
        };

        // Add dates if they exist
        if (startDate) params.start_date = startDate;
        if (endDate) params.end_date = endDate;

        console.log("Fetching stockists with params:", params);

        const response = await axios.get(
            `${BASE_URL}/api/stockist/list`,
            {
                params: params,
                headers: getAuthHeaders()
            }
        );

        console.log("Stockists fetched:", response.data);
        setStockists(response.data);

    } catch (err) {
        console.error("Error filtering stockists:", err);
        alert("Failed to fetch stockists. Please try again.");
    } finally {
        setLoading(false);
    }
};

    // Add these functions to your component (keep all existing code)
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Stockist Report</title>
                    <style>
                        table { border-collapse: collapse; width: 100%; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; }
                    </style>
                </head>
                <body>
                    <h2>Stockist Report</h2>
                    <table>
                        <thead className="text-white">
                            <tr>
                                <th>S.No</th>
                                <th>Stockist Name</th>
                                <th>Working Date</th>
                                <th>Visit</th>
                                <th>Mobile</th>
                                <th>HQ</th>
                                <th>Address</th>
                                <th>GSTIN</th>
                                <th>DL NO</th>
                                <th>POB</th>
                                <th>SOB</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${stockists.map((stockist, index) => `
                                <tr>
                                    <td>${index + 1}</td>
                                    <td>${stockist.stockist_name || 'N/A'}</td>
                                    <td>${stockist.working_date || 'N/A'}</td>
                                    <td>${stockist.visits || 'N/A'}</td>
                                    <td>${stockist.mobile || 'N/A'}</td>
                                    <td>${stockist.headquarter_name || 'N/A'}</td>
                                    <td>${stockist.address || 'N/A'}</td>
                                    <td>${stockist.gstin || 'N/A'}</td>
                                    <td>${stockist.dl_number || 'N/A'}</td>
                                    <td>${stockist.pob || 'N/A'}</td>
                                    <td>${stockist.sob || 'N/A'}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    const handleExportExcel = () => {
        // Create CSV content
        const headers = [
            'S.No', 'Stockist Name', 'Working Date', 'Visit', 
            'Mobile', 'HQ', 'Address', 'GSTIN', 'DL NO', 'POB', 'SOB'
        ].join(',');

        const rows = stockists.map((stockist, index) => [
            index + 1,
            `"${stockist.stockist_name || 'N/A'}"`,
            `"${stockist.working_date || 'N/A'}"`,
            `"${stockist.visits || 'N/A'}"`,
            `"${stockist.mobile || 'N/A'}"`,
            `"${stockist.headquarter_name || 'N/A'}"`,
            `"${stockist.address || 'N/A'}"`,
            `"${stockist.gstin || 'N/A'}"`,
            `"${stockist.dl_number || 'N/A'}"`,
            `"${stockist.pob || 'N/A'}"`,
            `"${stockist.sob || 'N/A'}"`
        ].join(','));

        const csvContent = [headers, ...rows].join('\n');

        // Create download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `stockist_report_${new Date().toISOString().slice(0,10)}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="stockist-report-page">
            <div className="container">
                {/* Filter Section */}
                <div className="filter-container">
                    <div className="filter-group">
                        <label>State:</label>
                        <select 
                            value={selectedState} 
                            onChange={(e) => handleStateChange(e.target.value)}
                        >
                            <option value="">Select State</option>
                            {states.map(state => (
                                <option key={state.id} value={state.id}>{state.name}</option>
                            ))}
                        </select>
                    </div>
    
                    <div className="filter-group">
                        <label>Division:</label>
                        <select 
                            value={selectedDivision} 
                            onChange={(e) => handleDivisionChange(e.target.value)} 
                            disabled={!selectedState}
                        >
                            <option value="">Select Division</option>
                            {divisions.map(division => (
                                <option key={division.id} value={division.id}>{division.name}</option>
                            ))}
                        </select>
                    </div>
    
                    <div className="filter-group">
                        <label>Employee:</label>
                        <select 
                            value={selectedEmployee} 
                            onChange={(e) => setSelectedEmployee(e.target.value)} 
                            disabled={!selectedDivision}
                        >
                            <option value="">Select Employee</option>
                            {employees.map(employee => (
                                <option key={employee.id} value={employee.id}>
                                    {employee.first_name} {employee.last_name} | {employee.designation} | {employee.headquarter_name} | {employee.division} | {employee.state_name}
                                </option>
                            ))}
                        </select>
                    </div>
    
                    <div className="filter-group">
                        <label>Start Date:</label>
                        <input 
                            type="date" 
                            value={startDate} 
                            onChange={(e) => setStartDate(e.target.value)} 
                        />
                    </div>
    
                    <div className="filter-group">
                        <label>End Date:</label>
                        <input 
                            type="date" 
                            value={endDate} 
                            onChange={(e) => setEndDate(e.target.value)} 
                        />
                    </div>
    
                    <div className="filter-group">
                        <button 
                            className="fetch-data-btn" 
                            onClick={filterStockists}
                            disabled={loading || !selectedEmployee}
                        >
                            {loading ? "Loading..." : "Fetch Data"}
                        </button>
                    </div>
                </div>
    
                {/* Table Section */}
                <div className="table-container">
                    {loading ? (
                        <div className="loading">Loading data...</div>
                    ) : (
                        <table>
                            <thead className="text-white">
                                <tr>
                                    <th>S.No</th>
                                    <th>Stockist Name</th>
                                    <th>Working Date</th>
                                    <th>Visit</th>
                                    <th>Mobile</th>
                                    <th>HQ</th>
                                    <th>Address</th>
                                    <th>GSTIN</th>
                                    <th>DL NO</th>
                                    <th>POB</th>
                                    <th>SOB</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stockists.length > 0 ? (
                                    stockists.map((stockist, index) => (
                                        <tr key={stockist.stockist_code}>
                                            <td>{index + 1}</td>
                                            <td>{stockist.stockist_name}</td>
                                            <td>{stockist.working_date || "N/A"}</td>
                                            <td>{stockist.visits || "N/A"}</td>
                                            <td>{stockist.mobile}</td>
                                            <td>{stockist.headquarter_name || "N/A"}</td>
                                            <td>{stockist.address || "N/A"}</td>
                                            <td>{stockist.gstin || "N/A"}</td>
                                            <td>{stockist.dl_number || "N/A"}</td>
                                            <td>{stockist.pob_targets ?? "N/A"}</td>
                                            <td>{stockist.sob_targets ?? "N/A"}</td>


                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="11">
                                            {selectedEmployee ? "No stockists found for this employee" : "Please select an employee and click Fetch Data"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
    
                {/* Buttons */}
                <div className="button-container">
                    <button className="print-btn" onClick={handlePrint}>🖨️ Print</button>
                    <button className="export-btn" onClick={handleExportExcel}>📥 Export to Excel</button>
                </div>
            </div>
        </div>
    );
};

export default StockistMissedCall;